<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-sync"
          :text="$t('ui.refresh')"
          type="button"
          @click="getProviderRtpList()"
          variant="primary"
          size="sm"
        )
  .card-body(style="max-width:1000px;")
    .row
      .col-md-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="5%")
                  span #
                th(width="10%")
                  span(:title="$t('ui.provider_code')") {{ $t('ui.provider_code') }}
                th(width="20%")
                  span(:title="$t('ui.provider_name')") {{ $t("ui.provider_name") }}
                th(width="10%")
                  span(:title="$t('ui.rtp')") {{ $t("ui.rtp") }}
                th.text-center(width="8%" v-if="isEditAccess")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
            tbody.clusterize-content
              tr(v-if="rtpList.length == 0")
                td(:colspan="isEditAccess ? '5' : '4'").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in rtpList")
                td.text-center
                  span(:title="index + 1") {{ index + 1 }}
                td
                  span(:title="item.provider_code") {{ item.provider_code }}
                td
                  span(:title="item.provider_name") {{ item.provider_name }}
                td
                  span(:title="item.rtp") {{ item.rtp }}
                td.text-center(v-if="isEditAccess")
                  span
                    a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")

    editproviderrtp(ref="editproviderrtp" :item="editSelectedProvider" @clicked="afterEdit" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import editproviderrtp from "@/components/setup/editProviderRtp.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editproviderrtp,
  },
  data: () => ({
    loading: false,
    rtpList: [],
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedProvider: null,
  }),
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    
    isEditAccess() {
      return this.$helpers.showActionButton("e_providerrtp");
    }
  },
  mounted: function() {
    // this.getProviderRtpList();
  },
  methods: {
    refresh() {
      this.getProviderRtpList()
    },
    onEdit(e) {
      this.editSelectedProvider = e;
      this.$refs.editproviderrtp.$refs.editProviderRtp.show();
    },
    afterEdit: function(item) {
      this.getProviderRtpList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_provider_rtp"), this.$t("message.success"), "success");
    },
    getProviderRtpList: function() {
      let url = config.providerRtpListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.rtpList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>